import { defaultEditorTheme } from './templateEditor.theme'
import { BroadcastTemplateDocument, CanvasBgMedia, TemplateElement } from './templateEditor.types'
import { clampCanvasSize } from './templateEditor.utils'

const theme = defaultEditorTheme

export type TemplateEditorDocumentState = {
    name: string
    canvasW: number
    canvasH: number
    canvasBg: string
    canvasBgMedia: CanvasBgMedia | null
    showGrid: boolean
    gridSize: number
    elements: TemplateElement[]
}

export const createEmptyBroadcastDocument = (): BroadcastTemplateDocument => ({
    schemaVersion: 1,
    canvas: {
        w: theme.defaultCanvasW,
        h: theme.defaultCanvasH,
        bg: theme.defaultCanvasBg,
        bgMedia: null,
        showGrid: false,
        gridSize: theme.defaultGridSize,
    },
    elements: [],
})

export const serializeBroadcastDocument = ({
    canvasW,
    canvasH,
    canvasBg,
    canvasBgMedia,
    showGrid,
    gridSize,
    elements,
}: Omit<TemplateEditorDocumentState, 'name'>): BroadcastTemplateDocument => ({
    schemaVersion: 1,
    canvas: {
        w: canvasW,
        h: canvasH,
        bg: canvasBg,
        bgMedia: canvasBgMedia,
        showGrid,
        gridSize,
    },
    elements,
})

export const normalizeBroadcastDocument = (
    document: BroadcastTemplateDocument | null | undefined
): BroadcastTemplateDocument => {
    const fallback = createEmptyBroadcastDocument()
    const canvas = document?.canvas
    const elements = document?.elements

    return {
        schemaVersion: typeof document?.schemaVersion === 'number' ? document.schemaVersion : 1,
        canvas: {
            w: clampCanvasSize(Number(canvas?.w) || fallback.canvas.w, theme),
            h: clampCanvasSize(Number(canvas?.h) || fallback.canvas.h, theme),
            bg: typeof canvas?.bg === 'string' ? canvas.bg : fallback.canvas.bg,
            bgMedia: canvas?.bgMedia ?? null,
            showGrid: Boolean(canvas?.showGrid),
            gridSize: Number(canvas?.gridSize) || fallback.canvas.gridSize,
        },
        elements: Array.isArray(elements) ? elements : [],
    }
}

export const getDocumentFingerprint = (name: string, document: BroadcastTemplateDocument) =>
    JSON.stringify({ name, document: normalizeBroadcastDocument(document) })
